import { YhPageHeader } from "@/components/YhPageHeader";
import { InfoBox } from "./InfoBox";
import { AccountDataBox } from "./account/AccountDataBox";
import { OpenDataBox } from "./open/OpenDataBox";
import { AdjustDataBox } from "./adjust/AdjustDataBox";
import { ContractDataBox } from "./contract/ContractDataBox";
import { StatementDataBox } from "./statement/StatementDataBox";
import { BillDataBox } from "./bill/BillDataBox";
import { RechargeDataBox } from "./recharge/index";
import { DetailActionTypeEnum, useDetailModel } from "./detailModel";

/**
 * 内容区判断
 */
const DetailDataBox = () => {
    const { actionType } = useDetailModel();

    switch (actionType) {
        case DetailActionTypeEnum.ACCOUNT:
            return <AccountDataBox />;
        case DetailActionTypeEnum.ADJUST:
            return <AdjustDataBox />;
        case DetailActionTypeEnum.RECHARGE:
            return <RechargeDataBox />;
        case DetailActionTypeEnum.OPEN:
            return <OpenDataBox />;
        case DetailActionTypeEnum.CONTRACT:
            return <ContractDataBox />;
        case DetailActionTypeEnum.STATEMENT:
            return <StatementDataBox />;
        case DetailActionTypeEnum.BILL:
            return <BillDataBox />;
        default:
            return <></>
    }
}

export const CustomerDetail = () => {

    return (
        <>
            <YhPageHeader title="合约详情" />
            <InfoBox />
            <DetailDataBox />
        </>
    )
}